import { wrappedFunctions } from './viewerScript';

export const initAppForPage = wrappedFunctions.initAppForPage;
export const createControllers = wrappedFunctions.createControllers;
export const exports = {};
